import { getAddress } from '1stdibs-contracts/addresses';
import { AUCTION_CONTRACT_NAME } from '1stdibs-contracts/contractNames';
import { getChainIdFromEnv, chains } from 'dibs-crypto-utils/exports/supportedChains';

export function getAuctionContractAddress(): string | null {
    const chainId = getChainIdFromEnv();
    const chainName = chains.get(chainId);

    return chainName ? getAddress(AUCTION_CONTRACT_NAME, chainName.toLowerCase()) : null;
}
